<template>
  <div>
    <Header />
    <Sidebar ref="sidebar" />
    <transition name="move" mode="out-in">
      <div class="content-box" :class="[tt, { 'content-mobile': isMobile }]">
        <Right/>
      </div>
    </transition>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Sidebar from "@/components/Sidebar";
import Right from '@/components/Right';
export default {
  name: "Home",
  components: { Header, Sidebar, Right },
  data() {
    return {
      tt: '',
      isMobile: false
    }
  },
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth < 768;
    }
  },
  created() {
    this.$bus.$on('tt', (data) => {
      if (data) {
        this.tt = 'content-collapse'
      } else {
        this.tt = ''
      }
    });
    // 手机端侧边栏打开事件
    this.$bus.$on('mobile-sidebar-toggle', () => {
      if (this.$refs.sidebar) {
        this.$refs.sidebar.openMobileSidebar();
      }
    });
  }
};
</script>

<style>
</style>
